import React, { useEffect, useState } from 'react';
import { Button, Form, Image, Modal } from 'react-bootstrap';
import { FaBan, FaCheck, FaCity, FaEnvelope, FaEnvelopeOpenText, FaEye, FaFileExcel, FaPen, FaPlus, FaRecycle, FaRegEnvelope, FaRegHandPaper, FaRegQuestionCircle, FaTrash, FaUser } from 'react-icons/fa';
import InfoCotisation from './InfoCotisation';
import { cleanJson, quoteToDoubleQuote } from './utils/Columns';
import CotisationSel from './CotisationSel';
import TarifManuel from './TarifManuel';
import AdherentNewUpdate from './AdherentNewUpdate';
import ColumnChooser from './ColumnChooser';
import AdherentUpdateById from './AdherentUpdateById';
import MyDatatable from './MyDatatable';
import moment from 'moment';
import InfoComplete from './InfoComplete';
import InfoToValidate from './InfoToValidate';
import tribu from './assets/images/logo_tribu.png'; // Importez le chemin de votre image
import tribu_nb from './assets/images/logo_tribu_nb.png'; // Importez le chemin de votre image
import GenerePdf from './GenerePdf';
import AdhesionByAppel from './AdhesionByAppel';
import TribuAction from './TribuAction';
import { utils as xlsxUtils, writeFile } from 'xlsx';


const Adh = ({ gotoAuth, annee, tribus, reloadTribus }) => {

    const url = localStorage.getItem('url');
    // const annee = localStorage.getItem('annee');
    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];

    const [showMaj, setShowMaj] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    const [appelCotisationSel, setAppelCotisationSel] = useState({});
    // Filtrer les articles initialisés et non initialisés
    const code = localStorage.getItem('code');

    const [data, setData] = useState([]);
    const [dataNonVisible, setDataNonVisible] = useState([]);
    const [actif, setActif] = useState(true);
    // const [dataFiltered, setDataFiltered] = useState([]);

    useEffect(() => {
        if (url && url !== '' && annee && annee !== '') {
            getData();
        }
    }, [annee]);

    const getData = () => {
        let code = localStorage.getItem('code');
        console.log('code', code);
        if (code === '') {
            gotoAuth();
            return;
        }
        // Appel de l'API
        fetch(`${url}GetComplete/${annee}/${code}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                // console.log('Réponse du serveur:', data);
                if (data === '0' || !data.data)
                    gotoAuth();
                else {
                    let donnees = cleanJson(data.data);
                    let appels = cleanJson(data.appels);
                    // console.log('appels', appels);

                    donnees.forEach(e => {
                        // console.log(e.adherent_id, appels.filter(a => a.adherent_id === e.adherent_id));
                        e["appels"] = appels.filter(a => a.adherent_id === e.adherent_id);
                    });

                    let donneesVisible = donnees.filter(e => e.visible === 1);
                    let donneesNonVisibles = donnees.filter(e => e.visible === 0);

                    // console.log('donnees', donnees);
                    setData(donneesVisible);
                    setDataNonVisible(donneesNonVisibles);
                    if (JSON.stringify(adherentSel) !== '{}') {
                        let adh = donnees.find(e => e.adherent_id === adherentSel.adherent_id);
                        if (!adh) {
                            setAdherentSel({});
                        }
                        else
                            setAdherentSel(adh);
                    }
                    if (JSON.stringify(appelCotisationSel) !== '{}') {
                        let appel = appels.find(e => e.appel_cotisation_id === appelCotisationSel.appel_cotisation_id);
                        if (!appel) {
                            setAppelCotisationSel({});
                        }
                        else
                            setAppelCotisationSel(appel);
                    }
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const [showCotis, setShowCotis] = useState(false);
    const [cotisationSel, setCotisationSel] = useState({});

    const [showTarif, setShowTarif] = useState(false);
    const [showCotisSel, setShowCotisSel] = useState(false);
    const [showNewCotisSel, setShowNewCotisSel] = useState(false);

    const handleDelCotisation = () => {
        console.log('handleDelCotisation', adherentSel, appelCotisationSel);
        if (window.confirm(`Êtes vous sûr de supprimer la cotisation de ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}UpdateCotisation/${appelCotisationSel.appel_cotisation_id}/0/0`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                        setShowCotisSel(false);
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    // const handleUpdateCotisation = (e) => {
    //     console.log('handleUpdateCotisation', e)
    //     let reference = cotisations.find(c => c.id === e.cotisation_id).reference;
    //     // console.log('handleChoixCotisation', e, reference);
    //     console.log('handleChoixCotisation', adherentSel);
    //     if (window.confirm(`Êtes vous sûr d'affecter la ${reference} à ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

    //         fetch(`${url}NewCotisation/${adherentSel.adherent_id}/${e.cotisation_id}/${e.choix_id}`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 // Traiter la réponse si nécessaire
    //                 console.log('Réponse du serveur:', data);
    //                 if (data === '0' || !data.status)
    //                     alert("rien à envoyer")
    //                 else {
    //                     console.log(data.data);
    //                     getData();
    //                 }
    //             })
    //             .catch(error => console.error('Erreur:', error));
    //     }
    // }

    const handleChoixCotisation = (e) => {
        console.log('handleChoixCotisation', e)
        let reference = cotisations.find(c => c.id === e.cotisation_id).reference;
        // console.log('handleChoixCotisation', e, reference);
        console.log('handleChoixCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr d'affecter la ${reference} à ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}UpdateCotisation/${appelCotisationSel.appel_cotisation_id}/${e.cotisation_id}/${e.choix_id}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleNewChoixCotisation = (e) => {
        console.log('handleChoixCotisation', e)
        let reference = cotisations.find(c => c.id === e.cotisation_id).reference;
        // console.log('handleChoixCotisation', e, reference);
        console.log('handleChoixCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr d'affecter la ${reference} à ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}NewCotisation/${adherentSel.adherent_id}/${e.cotisation_id}/${e.choix_id}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const [showTribu, setShowTribu] = useState(false);

    const handleTribu = (row) => {
        console.log(row);
        setAdherentSel(row);
        setShowTribu(true);
    }

    const handleMaj = (row) => {
        console.log(row);
        setAdherentIdSel(row.adherent_id);
        setShowMaj(true);
    }

    const handleRowClick = (row) => {
        console.log('Ligne cliquée :', row);
        //index of etats where etat = row.etat
        setAdherentSel(row);
    };

    const [showNew, setShowNew] = useState(false);

    const handleSaveAdherent = (editedAdh) => {
        fetch(`${url}NewAdherent/${code}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // remplace 'Invalid date' par '' dans le JSON
            body: JSON.stringify(quoteToDoubleQuote(editedAdh)).replace(/"Invalid date"/g, '""')
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                setAdherentSel(data);
                setShowNew(false);
                getData();
            })
            .catch(error => console.error('Erreur:', error));
    }
    const blocs = ['infoAdh', 'entreprise', 'effectif', 'abonnement', 'adhesion', 'tribu', 'siv', 'membre'];
    const champs = [
        { lib: 'civilite', required: false }, { lib: 'prenom_adherent', required: false }, { lib: 'nom_adherent', required: false }, { lib: 'adresse1', required: false }, { lib: 'adresse2', required: false }, { lib: 'code_postal', required: false, longueur: 5 }, { lib: 'ville', required: false }, { lib: 'telephone', required: true }, { lib: 'numero_de_portable', required: false }, { lib: 'e_mail_1', required: true }, { lib: 'e_mail_2', required: false }, { lib: 'e_mail_3', required: false }, { lib: 'numero_de_dpt', required: false }, { lib: 'numero_client', required: false }, { lib: 'region', required: false },

        { lib: 'nom_de_l_entreprise', required: false }, { lib: 'siret', required: true, longueur: 14 }, { lib: 'numero_tva_intracommunautaire', required: false }, { lib: 'code_ape_ou_naf', required: false }, { lib: 'forme_juridique_de_la_societe', required: false }, { lib: 'montant_du_capital', required: false }, { lib: 'code_metier', required: false },

        { lib: 'nbre_productifs', required: false }, { lib: 'nbre_apprentis', required: false }, { lib: 'total_personnel', required: false },

        { lib: 'acces_site_ffc_newsletter', required: false },

        { lib: 'acces_mediateur_consommation', required: false },

        { lib: 'reseau', required: false }, { lib: 'adh_depuis', required: true }, { lib: 'annee_de_cotisation', required: false }, { lib: 'date_paiement', required: false }, { lib: 'cotisation_nationale_t1', required: false }, { lib: 'cotisation_reseau', required: false }, { lib: 'cotisation_regionale', required: false }, { lib: 'cotisation_3_ans', required: false }, { lib: 'mode_de_paiement', required: false }, { lib: 'paiement_en_x_fois', required: false }, { lib: 'cnpa', required: false }, { lib: 'fnaa', required: false }, { lib: 'autre', required: false }, { lib: 'cotisation_id', required: false },

        { lib: 'has_tribu', required: false }, { lib: 'date_de_reglement', required: false }, { lib: 'fin_periode', required: false }, { lib: 'montant_tribu_regle_t2', required: false }, { lib: 'moyen_de_paiement', required: false }, { lib: 'paiement_en_x_fois', required: false }, { lib: 'identifiant_tribu', required: false },

        { lib: 'has_siv', required: false }, { lib: 'date_de_reglement_siv', required: false }, { lib: 'fin_periode_siv', required: false }, { lib: 'montant_regle_siv', required: false }, { lib: 'moyen_de_paiement_siv', required: false }, { lib: 'paiement_en_x_fois_siv', required: false },

        { lib: 'membre_bureau_ffc', required: false }, { lib: 'membre_conseil_national', required: false }, { lib: 'membres_conseil_admin', required: false }, { lib: 'titre', required: false },

    ];

    const [columnsSel, setColumnsSel] = useState(['Siret']);
    // const [columnsSel, setColumnsSel] = useState(['Siret', 'Entreprise', 'Nom', 'Adresse', 'Code postal', 'Ville', 'Téléphone', 'E-mail']);
    const [columns, setColumns] = useState([]);
    const [adherentIdSel, setAdherentIdSel] = useState(0);

    const handleFeuilleClick = (e, row, row2) => {
        e.preventDefault();
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        setAdherentSel(row);
        setAppelCotisationSel(row2);
        setShowCotisSel(true);
        return false

    };

    const handleNewFeuilleClick = (e, row, row2) => {
        e.preventDefault();
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        setAdherentSel(row);
        setAppelCotisationSel(row2);
        setShowNewCotisSel(true);
        return false

    };


    const handleCotisation = (row) => {
        // console.log(row, cotisations);
        let cotis = cotisations.find(c => c.id === row.cotisation_id);
        setAppelCotisationSel(row);
        // console.log(cotis);
        setCotisationSel(cotis);
        setShowCotis(true);
    }

    const [showAdh, setShowAdh] = useState(false);
    const [showManual, setShowManual] = useState(false);
    const [showMerge, setShowMerge] = useState(false);

    const handleShowAdh = (row) => {
        console.log('Ligne cliquée :', row);
        setAdherentSel(row);
        setShowAdh(true);
    }

    const handleShowManual = (row, row2) => {
        console.log('Manual :', row2);
        setAppelCotisationSel(row2);
        setAdherentSel(row);
        setShowManual(true);
    }

    const handleUnDelAdherent = (row) => {
        console.log('handleUnDelAdherent', row);
        if (window.confirm(`Êtes vous sûr de vouloir réactiver ${row.prenom_adherent} ${row.nom_adherent} ?`)) {

            fetch(`${url}UnDelAdherent/${row.adherent_id}/${code}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);

                    getData();
                    setActif(true);

                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleMerge = (row, row2) => {
        console.log(row, row2);
        let adh = { ...row, appel_cotisation_id: row2.appel_cotisation_id };
        console.log('adh', adh);
        setAdherentSel(adh);
        setTimeout(() => {
            setShowMerge(true);
        }, 500);
    }

    const OpenMail = (corps, subject, mail) => {
        // simulate click on href mailto : lien
        // console.log(lien);
        const link = document.createElement('a');
        const bodyEncoded = encodeURIComponent(corps);
        link.href = `mailto:${mail}?subject=${encodeURIComponent(subject)}&body=${bodyEncoded}`

        link.setAttribute(
            'target',
            '_blank',
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

    }

    const handleGetLien = (row, row2) => {
        console.log('handleGetLien', row, row2);
        if (window.confirm(`La création de ce lien rendra les liens précédemmeent envoyés inactifs.\r\nVoulez-vous créer un nouveau lien d'adhésion pour ${row.prenom_adherent} ${row.nom_adherent} ${row.e_mail_1} ?`)) {

            fetch(`${url}GetMailAvecLien/${code}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                // remplace 'Invalid date' par '' dans le JSON
                //adherent_id, cotisation_id, choix_id, code, mail
                body: JSON.stringify({ appel_cotisation_id: row2.appel_cotisation_id, adherent_id: row2.adherent_id, cotisation_id: row2.cotisation_id, mail: row.e_mail_1 })
            })
                .then(response => response.json())
                .then(data => {
                    if (data === '0' || !data.status)
                        gotoAuth();
                    else {
                        console.log(data.data);
                        OpenMail(data.corps.replace(/¤/g, '\n'), data.subject, data.mail);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    // concatene 2 objets
    const concat = (obj1, obj2) => {
        let obj = {};
        for (let key in obj1) {
            obj[key] = obj1[key];
        }
        for (let key in obj2) {
            obj[key] = obj2[key];
        }
        return obj;
    }

    const handleMail = (e, row, row2) => {
        e.stopPropagation();
        // console.log(row)

        if (window.confirm(`Voulez-vous envoyer une demande de cotisation à ${row.prenom_adherent} ${row.nom_adherent} ${row.e_mail_1} ?`)) {

            // fetch(`${url}SendCotisation/${row.adherent_id}/${code}`)
            fetch(`${url}SendCotisation/${code}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                // remplace 'Invalid date' par '' dans le JSON
                //adherent_id, cotisation_id, choix_id, code, mail
                body: JSON.stringify({ appel_cotisation_id: row2.appel_cotisation_id, adherent_id: row2.adherent_id, cotisation_id: row2.cotisation_id, mail: row.e_mail_1 })
            })
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    // console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        gotoAuth();
                    else {
                        // console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleSetColumns = (cols) => {
        console.log(cols);
        // ajouter : {
        //     name: 'Actions', width: '80px', cell: row => (<>
        //         <Button variant='secondary' onClick={() => handleShow(row)}><FaPen /></Button>
        //     </>),
        // },
        let colsNew = [
            ...cols, {
                name: 'Adhérent', selector: row => row.nom_adherent, cell: row => (<table>
                    <tbody>
                        <tr><td><b>{row.nom_de_l_entreprise}</b></td></tr>
                        <tr><td>{row.reseau}</td></tr>
                        <tr><td><FaUser />&nbsp;{row.civilite} {row.nom_adherent} {row.prenom_adherent}</td></tr>
                        <tr><td><FaRegEnvelope />&nbsp;{row.e_mail_1}</td></tr>
                        <tr><td><FaCity />&nbsp;{row.ville} ({row.numero_de_dpt})</td></tr>
                    </tbody>
                </table>), sortable: true, wrap: true
            },
            {
                name: '', width: '70px', selector: row => row.nom_adherent, cell: row => (<table className='text-center' width={'100%'}>
                    <tbody>
                        <tr><td><Button variant='outline-primary' size='sm' onClick={() => handleShowAdh(row)}><FaEye /></Button></td></tr>
                        <tr><td><Button variant='outline-primary' size='sm' onClick={() => handleMaj(row)}><FaPen /></Button></td></tr>
                        {/* <tr><td><Button variant='outline-primary' size='sm' onClick={() => handleTribu(row)} style={{ whiteSpace: 'nowrap' }}><Image src={tribu} style={{ width: '20px' }} /><br/>
                        {row.identifiant_tribu}</Button></td></tr> */}
                    </tbody>
                </table>), sortable: true, wrap: true
            },
            // region
            // {
            //     name: 'Région', selector: row => row.region, cell: row => (<>
            //         {row.region}
            //     </>), sortable: true, wrap: true
            // },
            {
                name: <><Image src={tribu} style={{ width: '36px' }} /></>, selector: row => {
                    if (row.identifiant_tribu && row.identifiant_tribu !== '') {
                        // if (row.has_tribu === 1 && row.has_tribu_actif === 1) return "OK"; // check vert
                        if (row.has_tribu === 0 && row.has_tribu_actif === 1) return "KO1"; // ban rouge
                        if (row.has_tribu === 1 && row.has_tribu_actif === 0) return "KO2"; // ban rouge
                        if (row.has_tribu === 0 && row.has_tribu_actif === 0) return "KO4"; // ban rouge
                    } else {
                        if (row.has_tribu === 1 && row.has_tribu_actif === 1) return "KO3"; // ban rouge
                    }
                    return "";
                }, cell: row => {
                    if (row.identifiant_tribu && row.identifiant_tribu !== '') {
                        if (row.has_region === 1)
                            return (
                                <div className="row">
                                    <div className="col-12">
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                            {/* <Button
                                                variant="link"
                                                size="sm"
                                                onClick={() => handleTribu(row)}
                                                style={{ whiteSpace: 'nowrap', marginRight: '10px' }}
                                            > */}
                                            {row.identifiant_tribu}&nbsp;

                                            {row.has_tribu === 1 && (
                                                <><FaCheck style={{ color: 'green', marginRight: '10px' }} /></>
                                            )}
                                            {/* </Button> */}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        {row.region && row.region !== 'FR' && <>(région : {row.region})</>}
                                        {row.reseau && <>(réseau : {row.reseau})</>}
                                    </div>
                                    {row.has_tribu === 0 && (<div className="col-12">

                                        <FaBan style={{ color: 'red', marginRight: '10px' }} /><br />Tribu non sélectionné

                                    </div>)}
                                </div>

                            )
                        else if (!(row.has_tribu === 0 && row.has_tribu_actif === 0))
                            return (
                                <div className="row">
                                    <div className="col-12">
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                            {/* <Button
                                                variant="link"
                                                size="sm"
                                                onClick={() => handleTribu(row)}
                                                style={{ whiteSpace: 'nowrap', marginRight: '10px' }}
                                            > */}
                                            {row.identifiant_tribu}&nbsp;

                                            {row.has_tribu === 1 && row.has_tribu_actif === 1 && row.tft_id && (
                                                <><FaCheck style={{ color: 'green', marginRight: '10px' }} /></>
                                            )}
                                            {/* SAS 1 PARE-BRISE */}
                                            {row.has_tribu === 1 && row.has_tribu_actif === 0 &&
                                                row.appels.some(appel => (appel.cotisation_id === 7 || appel.parent === 7) &&
                                                    eval(appel.annee) < annee) && (
                                                    <><FaCheck style={{ color: 'green', marginRight: '10px' }} /></>
                                                )}
                                            {/* </Button> */}
                                            {!row.tft_id && (
                                                <><FaBan style={{ color: 'red', marginRight: '10px' }} /></>
                                            )}
                                            {row.has_tribu === 0 && row.has_tribu_actif === 1 && (
                                                <><FaBan style={{ color: 'red', marginRight: '10px' }} /></>
                                            )}

                                        </div>
                                        <div className="col-12">
                                            {/* 70172050000076 */}
                                            {!row.tft_id && (
                                                <>Pas de compte tribu associé</>
                                            )}
                                            {row.has_tribu === 0 && row.has_tribu_actif === 1 && (
                                                <>Devrait avoir tribu<br />d'après sa feuille</>
                                            )}
                                            {/* {JSON.stringify(row)} */}
                                            {row.has_tribu === 1 && row.has_tribu_actif === 0 &&
                                                !row.appels.some(appel => (appel.cotisation_id === 7 || appel.parent === 7) && eval(appel.annee) < annee)
                                                && (
                                                    <><FaBan style={{ color: 'red', marginRight: '10px' }} /><br />Ne devrait pas avoir tribu<br />déselectionner tribu</>
                                                )}
                                            {row.has_tribu === 0 && row.has_tribu_actif === 0 && (
                                                <><FaBan style={{ color: 'red', marginRight: '10px' }} /><br />KO mais il a un identifiant qui n'est plus utilisé</>
                                            )}
                                        </div>
                                    </div>
                                </div>

                            )
                        else if (row.has_tribu === 0 && row.has_tribu_actif === 0)
                            return (
                                <div className="containerbox center">
                                    <strike>
                                        {row.identifiant_tribu}
                                        <br />{moment(row.fin_periode).format('DD/MM/YYYY')}
                                    </strike>

                                </div>
                            )
                    }
                    else
                        return (
                            <div className="containerbox">
                                {/* {(row.has_tribu_actif === 1 || row.has_region === 1) && <>Créez le compte tribu
                                    <div className="containerbox">
                                        <div className="d-grid gap-2">
                                            <Button variant="outline-light" size="sm" onClick={(e) => handleTribu(row)}>
                                                <FaPlus style={{ color: 'green' }} />
                                            </Button>
                                        </div>
                                    </div>
                                </>} */}
                                {(row.has_tribu_actif === 1 || row.has_region === 1) && <>Devrait avoir tribu<br />d'après sa fiche<br /></>}
                                {/* {row.has_region === 1 && <>Il pourrait avoir tribu <br />(région {row.region})</>} */}
                                {row.has_region === 1 && row.region && row.region !== 'FR' && <>(région : {row.region})</>}
                                {row.has_region === 1 && row.reseau && row.region === 'FR' && <>(réseau : {row.reseau})</>}
                                {/* {row.has_region === 0 && <>Il devrait avoir tribu</>} */}
                            </div>
                        )
                    // else
                    //     return (
                    //         <div className="containerbox">
                    //             <div className="d-grid gap-2">
                    //                 <Button variant="outline-light" size="sm" onClick={(e) => handleTribu(row)}>
                    //                     <FaPlus style={{ color: 'green' }} />
                    //                 </Button>
                    //             </div>
                    //         </div>
                    //     )

                }, sortable: true, wrap: true
            },
            //ne pas afficher la prochaine colonne si showvisible is true
            {
                name: 'Appels', selector: row => row.appels, cell: row => (<div className="containerbox">
                    {row.appels.map((row2, index) => (<>
                        <div key={'Appels_' + index} className={`box${index < row.appels.length - 1 ? '2' : ''}`}>
                            <table>
                                <tbody>
                                    <tr><td>
                                        {(row2.reference === undefined || row2.reference === null || row2.reference === '') && <Button variant="outline-danger" style={{ padding: '0px' }} onClick={(e) => handleFeuilleClick(e, row, row2)}>Feuille ?</Button>}
                                        {row2?.has_merged !== 1 && !(row2.reference === undefined || row2.reference === null || row2.reference === '') && <>
                                            <Button variant="link" style={{ padding: '0px' }} onClick={(e) => handleFeuilleClick(e, row, row2)}>{row2.reference}</Button>&nbsp;<FaRegQuestionCircle onClick={(e) => handleCotisation(row2)} />
                                        </>}
                                        {row2?.has_merged === 1 && <div style={{ whiteSpace: 'nowrap' }}>
                                            {row2.reference}&nbsp;<FaRegQuestionCircle onClick={(e) => handleCotisation(row2)} />
                                            {/* &nbsp;<FaPlus style={{ color: 'green' }} onClick={(e) => handleNewFeuilleClick(e, row, row2)} /> */}
                                            {row2.cotisation_id === 7 && <>&nbsp;{row2.annee_facture}</>}
                                        </div>}
                                    </td></tr>
                                    {row2.type && row2.type !== '' && <>
                                        {/* <tr><td>
                            {etats.find(e => e.etat === row2.etat)?.title}
                        </td></tr> */}

                                        <tr><td>
                                            {row2.type} en {row2.nb_fois} fois
                                        </td></tr>
                                        <tr><td>
                                            FFC : {row2.montant_ffc} € -&nbsp;
                                            {row2.montant_tribu > 0 && <><Image src={tribu} style={{ width: '40px' }} /> : {row2.montant_tribu} €</>}
                                            {!(row2.montant_tribu > 0) && <><Image src={tribu_nb} style={{ width: '40px' }} /></>}
                                        </td></tr>
                                        <tr><td>
                                            {row2.somme_paid} € / {row2.montant} €
                                        </td></tr>
                                        {row2?.has_merged === 1 && <tr><td>
                                            <div className="d-grid gap-2">
                                                <Button variant="outline-light" size="sm" onClick={(e) => handleNewFeuilleClick(e, row, row2)}>
                                                    <FaPlus style={{ color: 'green' }} />
                                                </Button>
                                            </div>
                                        </td></tr>}


                                    </>}
                                </tbody></table>
                        </div>
                    </>))}</div>), sortable: true, wrap: true
            },
            {
                name: '', width: '150px', selector: row => row.reference, cell: row =>
                (<div className="containerbox">
                    {row.appels.map((row2, index) => (<div className={`box${index < row.appels.length - 1 ? '2' : ''}`}>
                        {row2?.has_merged !== 1 && row2.reference !== '' && <Button variant='outline-secondary' size='sm' onClick={(e) => handleMail(e, row, row2)}><FaEnvelope /></Button>}
                        <Button variant='outline-primary' size='sm' onClick={() => handleShowManual(row, row2)}><FaRegHandPaper /></Button>
                        {row2?.has_merged !== 1 && row2.reference !== '' && row2.paid !== 1 &&
                            <Button variant='outline-warning' size='sm' onClick={() => handleGetLien(row, row2)}><FaEnvelopeOpenText /></Button>
                        }
                    </div>))}</div>), sortable: true, wrap: true
            },
            // {
            //     name: 'Adhésion', selector: row => row.reference, cell: row => (<table>
            //         <tr><td>
            //             {row.reference === '' && <Button variant="outline-danger" style={{ padding: '0px' }} onClick={(e) => handleFeuilleClick(e, row)}>Feuille ?</Button>}
            //             {row?.has_merged !== 1 && row.reference !== '' && <>
            //                 <Button variant="link" style={{ padding: '0px' }} onClick={(e) => handleFeuilleClick(e, row)}>{row.reference}</Button>&nbsp;<FaRegQuestionCircle onClick={(e) => handleCotisation(row)} />
            //             </>}
            //             {row?.has_merged === 1 && <>
            //                 {row.reference}&nbsp;<FaRegQuestionCircle onClick={(e) => handleCotisation(row)} />
            //             </>}
            //         </td></tr>
            //         {row.type && row.type !== '' && <>
            //             {/* <tr><td>
            //                 {etats.find(e => e.etat === row.etat)?.title}
            //             </td></tr> */}
            //             <tr><td>
            //                 {row.type} en {row.nb_fois} fois
            //             </td></tr>
            //             <tr><td>
            //                 FFC : {row.montant_ffc} € -&nbsp;
            //                 {row.montant_tribu > 0 && <><Image src={tribu} style={{ width: '40px' }} /> : {row.montant_tribu} €</>}
            //                 {!(row.montant_tribu > 0) && <><Image src={tribu_nb} style={{ width: '40px' }} /></>}
            //             </td></tr>
            //             <tr><td>
            //                 {row.somme_paid} € / {row.montant} €
            //             </td></tr>
            //         </>}
            //     </table>), sortable: true, wrap: true
            // },
            // {
            //     name: '', width: '150px', selector: row => row.nom_adherent, cell: row => (<>
            //         {row?.has_merged !== 1 && row.reference !== '' && <Button variant='outline-secondary' size='sm' onClick={(e) => handleMail(e, row)}><FaEnvelope /></Button>}
            //         <Button variant='outline-primary' size='sm' onClick={() => handleShowManual(row)}><FaRegHandPaper /></Button>
            //         {row?.has_merged !== 1 && row.reference !== '' && row.paid !== 1 &&
            //             <Button variant='outline-warning' size='sm' onClick={() => handleGetLien(row)}><FaEnvelopeOpenText /></Button>
            //         }
            //     </>), sortable: true, wrap: true
            // },
            {
                name: 'Appel cotisation', width: '150px', selector: row => row.reference, cell: row =>
                (<div className="containerbox">
                    {row.appels.map((row2, index) => (<div className={`box${index < row.appels.length - 1 ? '2' : ''}`}>
                        <table><tbody>
                            <tr><td>
                                <FaEnvelope />&nbsp;{moment(row2.date_appel).format('DD/MM/YYYY')}
                            </td></tr>
                            <tr><td style={{ color: 'green', padding: '0px' }}>
                                {row2.reference === '' && !row2.is_actif && <>Feuille non sélectionnée</>}
                                {row2.reference !== '' && !row2.is_actif && <>Feuille sélectionnée</>}
                                {row2.is_actif === 1 && row2.has_connected === 0 && <>Mail envoyé</>}
                                {row2.is_actif === 1 && row2.has_connected === 1 && row2.has_filled === 0 && <>S'est connecté</>}
                                {row2.is_actif === 1 && row2.has_filled === 1 && row2.has_selected_paiement === 0 && <>A remplit ses informations</>}
                                {row2.is_actif === 1 && row2.has_selected_paiement === 1 && row2.has_merged === 0 && <>A sélectionné son moyen de paiement</>}
                                {row2.is_actif === 1 && row2.has_merged === 1 && row2.paid === 0 && <>Données validé par la FFC</>}
                                {row2.is_actif === 1 && row2.paid === 1 && row2.has_merged === 1 && <>Dossier finalisé</>}
                                &nbsp;<FaCheck />
                            </td></tr>
                            <tr><td style={{ color: 'orange', padding: '0px' }}>
                                {!(row2.paid === 1 && row2.has_merged === 1) && <>...&nbsp;</>}
                                {/* {Object.keys(row2.has_merged).length === 0 && row2.is_actif !== 1 && row2.is_actif !== 0 && <Button variant='secondary' onClick={(e) => handleMail(e, row2)}><FaEnvelope /></Button>} */}
                                {row2.reference === '' && !row2.is_actif && <>feuille à sélectionner</>}
                                {row2.reference !== '' && !row2.is_actif && <>mail à envoyer</>}
                                {row2.is_actif === 1 && row2.has_connected === 0 && <>connexion</>}
                                {row2.is_actif === 1 && row2.has_connected === 1 && row2.has_filled === 0 && <>remplissage de ses informations</>}
                                {row2.is_actif === 1 && row2.has_filled === 1 && row2.has_selected_paiement === 0 && <>sélection de moyen de paiement</>}
                                {row2.is_actif === 1 && row2.has_selected_paiement === 1 && row2.has_merged === 0 && <>vérification des données par la FFC</>}
                                {row2.is_actif === 1 && row2.has_merged === 1 && row2.paid === 0 && <>paiement</>}
                                {/* {row.is_actif === 1 && row.paid === 1 && <>Rien</>} */}
                                {/* {"" + row.is_actif + row.has_connected + row.has_merged} */}
                            </td></tr>
                        </tbody></table>
                    </div>))}</div>), sortable: true, wrap: true
            },
            // {
            //     name: 'Appel cotisation', selector: row => row.nom_adherent, cell: row => (<table>
            //         <tr><td>
            //             <FaEnvelope />&nbsp;{moment(row.date_appel).format('DD/MM/YYYY')}
            //         </td></tr>
            //         <tr><td style={{ color: 'green', padding: '5px' }}>
            //             {row.reference === '' && !row.is_actif && <>Feuille non sélectionnée</>}
            //             {row.reference !== '' && !row.is_actif && <>Feuille sélectionnée</>}
            //             {row.is_actif === 1 && row.has_connected === 0 && <>Mail envoyé</>}
            //             {row.is_actif === 1 && row.has_connected === 1 && row.has_filled === 0 && <>S'est connecté</>}
            //             {row.is_actif === 1 && row.has_filled === 1 && row.has_selected_paiement === 0 && <>A remplit ses informations</>}
            //             {row.is_actif === 1 && row.has_selected_paiement === 1 && row.has_merged === 0 && <>A sélectionné son moyen de paiement</>}
            //             {row.is_actif === 1 && row.has_merged === 1 && row.paid === 0 && <>Données validé par la FFC</>}
            //             {row.is_actif === 1 && row.paid === 1 && row.has_merged === 1 && <>Dossier finalisé</>}
            //             &nbsp;<FaCheck />
            //         </td></tr>
            //         <tr><td style={{ color: 'orange', padding: '5px' }}>
            //             {!(row.paid === 1 && row.has_merged === 1) && <>...&nbsp;</>}
            //             {/* {Object.keys(row.has_merged).length === 0 && row.is_actif !== 1 && row.is_actif !== 0 && <Button variant='secondary' onClick={(e) => handleMail(e, row)}><FaEnvelope /></Button>} */}
            //             {row.reference === '' && !row.is_actif && <>feuille à sélectionner</>}
            //             {row.reference !== '' && !row.is_actif && <>mail à envoyer</>}
            //             {row.is_actif === 1 && row.has_connected === 0 && <>connexion</>}
            //             {row.is_actif === 1 && row.has_connected === 1 && row.has_filled === 0 && <>remplissage de ses informations</>}
            //             {row.is_actif === 1 && row.has_filled === 1 && row.has_selected_paiement === 0 && <>sélection de moyen de paiement</>}
            //             {row.is_actif === 1 && row.has_selected_paiement === 1 && row.has_merged === 0 && <>vérification des données par la FFC</>}
            //             {row.is_actif === 1 && row.has_merged === 1 && row.paid === 0 && <>paiement</>}
            //             {/* {row.is_actif === 1 && row.paid === 1 && <>Rien</>} */}
            //             {/* {"" + row.is_actif + row.has_connected + row.has_merged} */}
            //         </td></tr>
            //     </table>), sortable: true, wrap: true
            // },

            {
                name: '', width: '70px', selector: row => row.reference, cell: row =>
                (<div className="containerbox">
                    {row.appels.map((row2, index) => (<div className={`box${index < row.appels.length - 1 ? '2' : ''}`}>
                        {row2.is_actif === 1 && row2.has_selected_paiement === 1 && row2.has_merged === 0 && <Button variant='outline-primary' size='sm' onClick={() => handleMerge(row, row2)}><FaEnvelopeOpenText /></Button>}
                    </div>))}</div>), sortable: true, wrap: true
            },
            {
                name: 'Facture', width: '70px', selector: row => row.reference, cell: row =>
                (<div className="containerbox">
                    {row.appels.map((row2, index) => (<div className={`box${index < row.appels.length - 1 ? '2' : ''}`}>
                        {row2.paid === 1 && row2.has_merged === 1 && <><GenerePdf fichier='facture' data={concat(row, row2)} visible={true} /></>}
                    </div>))}</div>), sortable: true, wrap: true
            },
            //button undelete
            {
                name: '', width: '70px', selector: row => row.reference, cell: row =>
                    (<Button variant='outline-success' alt='Réactiver' size='xl' onClick={() => handleUnDelAdherent(row)}><FaRecycle /></Button>), sortable: true, wrap: true
            },


            // {
            //     name: '', width: '70px', selector: row => row.nom_adherent, cell: row => (<>
            //         {row.is_actif === 1 && row.has_selected_paiement === 1 && row.has_merged === 0 && <Button variant='outline-primary' size='sm' onClick={() => handleMerge(row)}><FaEnvelopeOpenText /></Button>}
            //     </>), sortable: true, wrap: true
            // },
            // {
            //     name: 'Facture', width: '90px', selector: row => row.paid, cell: row => (<>
            //         {row.paid === 1 && row.has_merged === 1 && <><GenerePdf fichier='facture' data={row} visible={true} />
            //         </>}
            //     </>), sortable: true, wrap: true
            // },

            // {
            //     name: 'Actions', width: '80px', cell: row => (<>
            //         <Button variant='secondary' onClick={() => handleMaj(row)}><FaPen /></Button>
            //     </>),
            // },
        ]
        setColumns(colsNew);
    }

    const selection = [{ lib: 'Tout', val: '*' }, { lib: 'A valider', val: 'avalider' }, { lib: 'Sans feuille', val: 'sansfeuille' },
        // { lib: 'Tribu OK', val: 'tribuok' }, { lib: 'Tribu KO', val: 'tribuko' }, { lib: 'Tribu compte KO', val: 'tribucompte' }
    ]
    const [filtreParSelect, setFiltreParSelect] = useState('*')
    const handleFiltreParSelect = (selected) => {
        setFiltreParSelect(selected)
    }

    const handleAfterModifTribu = () => {
        getData();
        setShowTribu(false);
        reloadTribus();
    }

    const handleExportExcel = () => {
        // Créer un nouveau classeur
        const wb = xlsxUtils.book_new();

        // Préparer les données pour l'export (uniquement les actifs)
        const exportData = (actif ? data : dataNonVisible).map(row => ({
            'SIRET': row.siret,
            'REGION': row.region,
            'FORME_JURIDIQUE_DE_LA_SOCIETE': row.forme_juridique_de_la_societe,
            'MONTANT_DU_CAPITAL': row.montant_du_capital,
            'NOM DE L\'ENTREPRISE': row.nom_de_l_entreprise,
            'NOM ADHERENT': row.nom_adherent,
            'PRENOM ADHERENT': row.prenom_adherent,
            'ADRESSE1': row.adresse1,
            'ADRESSE2': row.adresse2,
            'CODE POSTAL': row.code_postal,
            'VILLE': row.ville,
            'TELEPHONE': row.telephone,
            'NUMERO DE PORTABLE': row.numero_de_portable,
            'E-Mail 1': row.e_mail_1,
            'E-Mail 2': row.e_mail_2,
            'N° DE DPT': row.numero_de_dpt,
            'CODE METIER': row.code_metier,
            'NUMERO CLIENT': row.numero_client,
            'REGION': row.region,
            'NBRE PRODUCTIFS': row.nbre_productifs,
            'NBRE APPRENTIS': row.nbre_apprentis,
            'TOTAL PERSONNEL': row.total_personnel,
            'RESEAU': row.reseau,
            'ADH DEPUIS': row.adh_depuis,
            'ANNEE DE COTISATION': row.annee_de_cotisation,
            'DATE PAIEMENT': row.date_paiement ? moment(row.date_paiement).format('DD/MM/YY') : '',
            'COTISATION NATIONALE': row.cotisation_nationale_t1,
            'COTISATION RESEAU': row.cotisation_reseau,
            'NUMERO DE FEUILLE DE COTISATION': row.appels ? row.appels.map(appel => appel.reference).filter(ref => ref).join(', ') : '',
            'OU NUMERO DE FEUILLE DE COTISATION': row.ou_numero_de_feuille_de_cotisation,
            'COTISATION 3 ANS': row.appels ? row.appels.filter(appel => appel.sur_trois_ans && appel.sur_trois_ans>0).map(j => j.sur_trois_ans + ' SUR 3').filter(ref => ref).join(', ') : '',// row.sur_trois_ans && row.sur_trois_ans>=1 ?row.sur_trois_ans + ' SUR 3' : '',
            'MODE DE PAIEMENT': row.mode_de_paiement,
            'PAIEMENT EN X FOIS': row.paiement_en_x_fois,
            'CNPA': row.cnpa,
            'FNAA': row.fnaa,
            'AUTRE': row.autre,
            'ABONNE TRIBU O/N': row.has_tribu === 1 ? 'O' : 'N',
            'DATE DE REGLEMENT': row.date_de_reglement ? moment(row.date_de_reglement).format('DD/MM/YYYY') : '',
            'FIN PERIODE': row.fin_periode ? moment(row.fin_periode).format('DD/MM/YYYY') : '',
            'MONTANT TRIBU REGLE T2': row.montant_tribu_regle_t2,
            'MOYEN DE PAIEMENT': row.moyen_de_paiement,
            'PAIEMENT EN X FOIS v2': row.paiement_en_x_fois1,
            'IDENTIFIANT TRIBU': row.identifiant_tribu,
            'MEMBRE BUREAU FFC': row.membre_bureau_ffc === 1 ? 'O' : 'N',
            'MEMBRE CONSEIL NATIONAL': row.membre_conseil_national === 1 ? 'O' : 'N',
            'MEMBRES CONSEIL ADMINISTRATION': row.membres_conseil_admin === 1 ? 'O' : 'N',
            'TITRE': row.titre,
            'ACCES SITE FFC ET NEWSLETTER': row.acces_site_ffc_newsletter === 1 ? 'O' : 'N',
            'ABONNE FFC EXPERT': row.abonne_ffc_expert === 1 ? 'O' : 'N',
            'ABONNE MAG CARROSSERIE': row.abonne_mag_carrosserie === 1 ? 'O' : 'N',
            'ABONNE PROFESSION CARROSSIER': row.abonne_profession_carrossier === 1 ? 'O' : 'N',
            'ACCES MEDIATEUR CONSOMMATION': row.acces_mediateur_consommation === 1 ? 'O' : 'N',
            'ENREGISTRE SITE FFC': row.enregistre_site_ffc === 1 ? 'O' : 'N',
            'ENREGISTRE SITE MEDIATION': row.enregistre_site_mediation === 1 ? 'O' : 'N'
        }));

        // Créer une feuille de calcul
        const ws = xlsxUtils.json_to_sheet(exportData);
        
        // Ajouter la feuille au classeur
        xlsxUtils.book_append_sheet(wb, ws, "Adhérents");
        
        // Générer le fichier Excel
        writeFile(wb, `adherents_${annee}.xlsx`);
    };

    return (
        <div>
            {/* {JSON.stringify(adherentSel) !== '{}' && (<>
                <AdhesionByUser adherentId={adherentSel.adherent_id} gotoAuth={gotoAuth} unSelAdherent={() => setAdherentSel({})} />
            </>)} */}
            {/* {JSON.stringify(adherentSel) === '{}' && (<> */}
            {/* {JSON.stringify(tribus)} */}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                <h1>Synthèse&nbsp;<Button variant="danger" onClick={() => setShowNew(true)}>+</Button>&nbsp;<Button variant="success" onClick={handleExportExcel}><FaFileExcel /> Export Excel</Button></h1>
                
                <div style={{ flexGrow: 1 }} />
                <ColumnChooser columnsName={columnsSel} data={data} setColumns={handleSetColumns} />
            </div>
            {/* swith visible */}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                <div style={{ flexGrow: 1 }} />
                <Form.Check type="switch" id="custom-switch" label="Visible" checked={actif} onChange={() => setActif(!actif)} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '200px' }}
                    value={filtreParSelect}
                    onChange={(e) => handleFiltreParSelect(e.target.value)}
                >
                    {selection.map((item, index) => (
                        <option key={index} value={item.val}>{item.lib}</option>
                    ))}
                </Form.Select>
            </div>

            <MyDatatable data={actif ? data : dataNonVisible} subSelect={filtreParSelect} columns={columns} handleRowClick={handleRowClick} actif={actif} />

            {/* </>)} */}

            <Modal size="xl" show={showCotis} onHide={() => setShowCotis(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Cotisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoCotisation cotisation={cotisationSel} choix_id={appelCotisationSel.choix_id} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showCotisSel} onHide={() => setShowCotisSel(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Sélection d'une cotisation pour <b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button variant='outline-danger' onClick={handleDelCotisation}><FaTrash /></Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationSel gotoAuth={gotoAuth} handleChoixCotisation={handleChoixCotisation} closemodal={() => setShowCotisSel(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showNewCotisSel} onHide={() => setShowNewCotisSel(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Sélection d'une cotisation pour <b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button variant='outline-danger' onClick={handleDelCotisation}><FaTrash /></Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationSel gotoAuth={gotoAuth} handleChoixCotisation={handleNewChoixCotisation} closemodal={() => setShowNewCotisSel(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showTarif} onHide={() => setShowTarif(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>Selection du tarif</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TarifManuel adherentSel={adherentSel} reloadData={getData} />
                </Modal.Body>
            </Modal>
            <Modal size="xl" show={showMaj} onHide={() => setShowMaj(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modification</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*
                    reloadData, blocs, champs, adherentId, code, gotoAuth
                    */}
                    <AdherentUpdateById reloadData={getData} blocs={blocs} champs={champs} code={code} adherentId={adherentIdSel} gotoAuth={gotoAuth}
                        close={() => setShowMaj(false)} tribus={tribus} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showNew} onHide={() => setShowNew(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Nouvel adhérent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AdherentNewUpdate handleSaveAdherent={handleSaveAdherent} blocs={blocs} champs={champs} cotisation={''}
                        setCotisation={() => console.log('rien')} cotisation2={''} setCotisation2={() => console.log('rien')} code={code} tribus={tribus} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showAdh} onHide={() => setShowAdh(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <InfoComplete adherentLight={adherentSel} gotoAuth={gotoAuth} reloadData={getData} closeModal={() => setShowAdh(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showManual} onHide={() => setShowManual(false)}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <AdhesionByAppel appelCotisationId={appelCotisationSel.appel_cotisation_id} gotoAuth={gotoAuth}
                        unSelAdherent={() => { setAdherentSel({}); setShowManual(false); }} handleModifAdherent={getData} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showMerge} onHide={() => setShowMerge(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoToValidate adherentLight={adherentSel} gotoAuth={gotoAuth} reloadData={getData} closemodal={() => setShowMerge(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showTribu} onHide={() => setShowTribu(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* {JSON.stringify(tribus)} */}
                    <TribuAction annee={annee} adherentSel={adherentSel} tribus={tribus} handleAfterModif={handleAfterModifTribu} />
                </Modal.Body>
            </Modal>
        </div >
    );
}

export default Adh;
